"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CorrelationGroup = exports.useApiClientWithGroupCorrelationId = exports.CorrelationGroupContext = void 0;
const AppContext_1 = require("../utils/AppContext");
const kendo_react_common_1 = require("@progress/kendo-react-common");
const axios_1 = __importDefault(require("axios"));
const react_1 = __importDefault(require("react"));
exports.CorrelationGroupContext = react_1.default.createContext("");
exports.useApiClientWithGroupCorrelationId = (apiClient) => {
    const cgid = react_1.default.useContext(exports.CorrelationGroupContext);
    const newApiClient = react_1.default.useMemo(() => {
        const newClient = axios_1.default.create();
        if (apiClient) {
            Object.assign(newClient.defaults, apiClient.defaults);
            Object.assign(newClient.interceptors, apiClient.interceptors);
            Object.assign(newClient.defaults.headers, {
                "Correlation-Group-Id": cgid
            });
            return newClient;
        }
        return apiClient;
    }, [cgid, apiClient]);
    return newApiClient;
};
exports.CorrelationGroup = (props) => {
    const [correlationGroupId, setCorrelationGroupId] = react_1.default.useState(undefined);
    const parentGroupId = react_1.default.useContext(exports.CorrelationGroupContext);
    const { apiClient: client } = react_1.default.useContext(AppContext_1.AppContext);
    const apiClient = exports.useApiClientWithGroupCorrelationId(client);
    const { children } = props;
    react_1.default.useLayoutEffect(() => {
        setCorrelationGroupId(kendo_react_common_1.guid());
        return () => {
            if (apiClient && parentGroupId) {
                Object.assign(apiClient.defaults.headers, {
                    "Correlation-Group-Id": parentGroupId
                });
            }
        };
    }, [apiClient, parentGroupId]);
    return correlationGroupId ? (react_1.default.createElement(exports.CorrelationGroupContext.Provider, { value: correlationGroupId || "" }, children)) : null;
};
exports.CorrelationGroupContext.displayName = "CorrelationGroupContext";
exports.CorrelationGroup.displayName = "CorrelationGroup";
//# sourceMappingURL=CorrelationGroups.js.map